export default __webpack_public_path__ + "static/media/Group 10637.1de9d8de.svg";